<div class="dx-field">
  <div class="dx-field-label">{{ 'Quellkatalog' | translate }}</div>
  <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
    <label class="placeLabel {{ sourceCompareCatalog?.length > 0 ? 'placeLabelSmall' : '' }}">SOURCE CATALOG</label>
    <dx-select-box [(value)]="sourceCompareCatalog"
                   [dataSource]="catalogs"
                   displayExpr="catalogName"
                   [searchEnabled]="!isSourceCompareCatalogFixed"
                   [readOnly]="isSourceCompareCatalogFixed"
                   valueExpr="id"
                   placeholder="">

    </dx-select-box>
  </div>
</div>
<div class="dx-field">
    <div class="dx-field-label">{{ 'Änderungslog in Excel-Datei ausgeben' | translate }}</div>
    <div class="dx-field-value" style="text-align: left">
        <dx-switch [(value)]="exportChangeLog"></dx-switch>
    </div>
</div>
<div class="dx-field">
  <div class="dx-field-label">{{ 'Vergleich anhand von' | translate }}</div>
  <div class="dx-field-value">
    <dx-radio-group [items]="compareModeOptions"
                    [(value)]="useFieldList"
                    valueExpr="value"
                    displayExpr="text"
                    layout="horizontal"
                    (onValueChanged)="updateFieldListHeight()"></dx-radio-group>
  </div>
</div>
<div class="dx-field" *ngIf="!useFieldList">
  <div class="dx-field-label">{{ 'Export-Template' | translate }}</div>
  <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
    <label class="placeLabel {{ selectedTemplateId?.length > 0 ? 'placeLabelSmall' : '' }}">EXPORT TEMPLATE</label>
    <dx-select-box [(value)]="selectedTemplateId"
                   [dataSource]="templateService.exportTemplates"
                   displayExpr="name"
                   [searchEnabled]="true"
                   valueExpr="id"
                   noDataText="{{ 'keine Templates im Account' | translate }}"
                   placeholder="">
    </dx-select-box>
  </div>
</div>
<div #fieldListWrapper *ngIf="useFieldList" [style.height.px]="fieldListHeight">
  <fieldList [fields]="catalogService.fields"
             [fieldGroups]="fieldGroups"
             [(fieldListContainer)]="fieldListContainer"
             style="display: block; height: 100%"></fieldList>
</div>
